import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { finalBenefits, heroBadges } from '../../data/content';
export function FinalCTA() {
  return <section className="bg-ink-900 px-4 py-12 sm:py-16" data-id="element-100" data-mp="3msz26029h3xg">
      <div className="mx-auto max-w-2xl" data-id="element-101" data-mp="3rslfsam04m6s">
        <h2 className="text-center font-display text-[24px] leading-tight text-white sm:text-3xl" data-id="element-102" data-mp="3rrabm9on9cf5">
          Ogni rifinitura che riesci a evitare può significare:
        </h2>

        <ul className="mt-5 grid gap-2 sm:grid-cols-2" data-id="element-103" data-mp="3huxgd7dgaqia">
          {finalBenefits.map(benefit => <li key={benefit} className="flex items-start gap-2 rounded-xl border border-white/10 bg-ink-800 px-3.5 py-3 text-[13.5px] leading-snug text-white/80" data-id="element-104" data-mp="33vxvmat26vre">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-400" aria-hidden="true" data-id="element-105" data-mp="124korg7j6dsp" />
              {benefit}
            </li>)}
        </ul>

        <div className="mt-8 rounded-3xl border-2 border-brand-500/60 bg-ink-800 p-5 text-center" data-id="element-106" data-mp="q8dgoxbliws8">
          <h3 className="font-display text-[22px] leading-tight text-white sm:text-3xl" data-id="element-107" data-mp="l9sewtgp451o">
            Ottieni subito l’accesso al Sistema Anti-Rifiniture™
          </h3>
          <p className="mt-3 text-[11px] font-black uppercase tracking-[0.18em] text-brand-400" data-id="element-108" data-mp="z31ksk5fq8fg">
            Per soli
          </p>
          <p className="font-display text-[60px] leading-none text-white sm:text-7xl" data-id="element-109" data-mp="79hlpjrwyedc">€19</p>

          <ul className="mx-auto mt-4 grid max-w-sm grid-cols-2 gap-2" data-id="element-110" data-mp="2ay05kh8f4li">
            {heroBadges.map(badge => <li key={badge} className="flex items-center gap-1.5 rounded-xl bg-ink-900 px-2.5 py-2 text-[11.5px] font-semibold leading-tight text-white/75" data-id="element-111" data-mp="gaz458ssms57">
                <CheckIcon className="h-3.5 w-3.5 shrink-0 text-brand-400" aria-hidden="true" data-id="element-112" data-mp="1rotdl6x3v1by" />
                {badge}
              </li>)}
          </ul>

          <div className="mt-5" data-id="element-113" data-mp="kd3qc6r1cgg8">
            <CTAButton label="👉 Voglio scaricare il Sistema" sublabel="Cambio valuta automatico" data-id="element-114" data-mp="kdwssviyojsk" />
          </div>

          <div className="mt-5" data-id="element-115" data-mp="pavgav84dshs">
            <Countdown data-id="element-116" data-mp="pe18wkfyjci9" />
          </div>
        </div>
      </div>
    </section>;
}
export function Footer() {
  return <footer className="bg-ink-950 px-4 pb-28 pt-10 text-center sm:pb-24" data-id="element-117" data-mp="ycmllyyqzxb4">
      <p className="font-display text-sm text-white" data-id="element-118" data-mp="yaills3yzig4">
        Sistema Anti-Rifiniture™ · Dott.ssa Karito
      </p>
      <p className="mt-2 text-[12px] text-white/40" data-id="element-119" data-mp="5o7cft2as97p">© 2026 Tutti i diritti riservati.</p>
      <p className="mx-auto mt-1 max-w-sm text-[12px] leading-relaxed text-white/30" data-id="element-120" data-mp="5lusjaczbos0">
        Questo prodotto non sostituisce il giudizio clinico professionale.
      </p>
    </footer>;
}